import styled, { css } from 'styled-components';

import { DownArrowSmallIcon } from '../../../../icons';
import { colors, fontSizes, fontWeights, iconSizes } from '../../../../theme';
import { DataTableVariableNames } from '../../constants';
import { DataTableSortDirection } from '../../types';

const clickableCellStyles = css`
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: ${colors.navy};
    background-color: #e5e6eb;
  }

  &:focus-visible {
    outline: 1px solid ${colors.ocean};
  }
`;

export const Cell = styled.th<{
  onClick?: React.MouseEventHandler<HTMLTableCellElement>;
  $hasFilter: boolean;
}>`
  box-sizing: border-box;
  padding: ${({ theme, $hasFilter }) =>
    `${$hasFilter ? theme.core.spacing['3x'] : theme.core.spacing['6x']} ${
      theme.core.spacing['12x']
    }`};
  border: 0;
  text-align: start;

  svg {
    fill: currentColor;
  }

  ${({ onClick }) => (!onClick ? '' : clickableCellStyles)}
`;

export const CellLabel = styled.div`
  line-height: 12px;
  font-size: ${fontSizes.xxs};
  font-weight: ${fontWeights.medium};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellFilter = styled.div`
  line-height: 12px;
  font-size: ${fontSizes.xxs};
  font-weight: ${fontWeights.medium};
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(${DataTableVariableNames.FilterColor});
`;

export const ArrowIcon = styled(DownArrowSmallIcon)<{
  $direction?: DataTableSortDirection | null;
  $isSorted?: boolean;
}>`
  flex: 0 0 auto;
  width: ${iconSizes.s};
  height: ${iconSizes.s};
  transform: ${({ $direction, $isSorted }) => {
    if (!$isSorted) return null;
    if ($direction === 'asc') return 'rotate(0deg)';
    if ($direction === 'desc') return 'rotate(180deg)';
  }};
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  fill: ${({ $isSorted }) => ($isSorted ? colors.navy : colors.pigeon)};
`;
